import { InfoIcon, FileTextIcon, SirenIcon, WrenchIcon, GaugeIcon, TrendingUpIcon } from 'lucide-react'
import { t } from 'i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { IconButton } from '@asad/ui'
import colors from 'tailwindcss/colors'

type SideButtonsContainerProps = {
  id: string
}

const primary = colors.indigo[500]

const SideButtonsContainer = ({ id }: SideButtonsContainerProps) => {
  const location = useLocation()
  const navigate = useNavigate()
  const currentPath = location.pathname

  const buttons = [
    {
      path: `/device/${id}`,
      title: t('device.indicatorsTooltip'),
      icon: <GaugeIcon className='md:w-10 md:h-10' color={primary} />,
    },
    {
      path: `/device/${id}/help`,
      title: t('device.help'),
      icon: <InfoIcon className='md:w-10 md:h-10' color={primary} />,
    },
    {
      path: `/device/${id}/alarms`,
      title: t('device.alarmsAndWarningsStatistic'),
      icon: <SirenIcon className='md:w-10 md:h-10' color={primary} />,
    },
    {
      path: `/device/${id}/technical-inspection`,
      title: t('device.enterInspection'),
      icon: <WrenchIcon className='md:w-10 md:h-10' color={primary} />,
    },
    {
      path: `/device/${id}/technical-inspection-history`,
      title: t('device.inspectionList'),
      icon: <FileTextIcon className='md:w-10 md:h-10' color={primary} />,
    },
    // Feature temporarily disabled - Will be enable and implemented at version 2.0
    // {
    //   path: `/device/${id}/usage-monitoring`,
    //   title: t('device.usageMonitoring'),
    //   icon: <TrendingUpIcon className='md:w-10 md:h-10' color={primary} />,
    // },
  ]

  return (
    <div className='flex 2xl:flex-col gap-4'>
      {buttons.map(({ path, title, icon }) => (
        <IconButton
          title={title}
          key={uuidv4()}
          variant='tertiary'
          active={currentPath === path}
          onClick={() => navigate(path)}
          icon={icon}
          size='2xl'
          className='rounded-lg'
        />
      ))}
    </div>
  )
}

export default SideButtonsContainer
